import "../../css/dashboardIA.css";

// Componente único para los tres vacíos de spec.md §3.10 (RF-27a/b/c, RF-27e). No se escriben seis vacíos
// distintos a mano. Ninguna variante usa color de estado (--cp-status-*): un tablero sin datos no está en
// alerta, así que el ícono y el texto van en tinta secundaria/neutra.
//
// variante="pagina": RF-27a (vacío total, con CTA) y RF-27b (vacío por filtro, con "Limpiar filtros").
//   Ocupa el cuerpo entero.
// variante="tarjeta": RF-27c (una dimensión sin datos). Conserva el alto y el título de la tarjeta que la
//   envuelve; nunca lleva acción.
const EstadoVacio = ({ variante = "tarjeta", icon = "fa-inbox", titulo, descripcion, accion }) => (
  <div className={`dia-vacio dia-vacio--${variante}`}>
    <i className={`fa ${icon} dia-vacio__icono`} aria-hidden="true"></i>
    <h3 className="dia-vacio__titulo">{titulo}</h3>
    {descripcion && <p className="dia-vacio__descripcion">{descripcion}</p>}
    {accion && (
      <button type="button" className="brand-btn-action" onClick={accion.onClick}>
        {accion.icon && <i className={`fa ${accion.icon}`} aria-hidden="true"></i>}
        {accion.texto}
      </button>
    )}
  </div>
);

export default EstadoVacio;
